<template>
  <div>
    <transition name="fade">
      <div class="modal" v-show="isOpen">
        <transition name="drop-in">
          <div class="modal-inner" v-show="isOpen" ref="target">
            <div class="modal-content">
              <h1 class="title">{{ title }}</h1>
              <div class="flex justify-center" v-if="deviceGeoPlanLoading">
                <svg
                  aria-hidden="true"
                  class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              </div>
              <div
                class="flex justify-center"
                v-if="!deviceGeoPlanLoading && deviceGeoPlan === null"
              >
                <p class="font-semibold">No planning found!</p>
              </div>
              <div
                class="flex flex-col gap-4 items-start mb-6"
                v-if="!deviceGeoPlanLoading && deviceGeoPlan !== null"
              >
                <div class="flex flex-col text-left text-[#353535]">
                  <p class="font-semibold">Program No</p>
                  <p>
                    Program
                    {{ deviceGeoPlan.date[0].program.match(/(\d+)/)[0] }}
                  </p>
                </div>
                <div class="flex flex-col text-left text-[#353535]">
                  <p class="font-semibold">
                    {{
                      stationDetail.mode === "volume"
                        ? "Activation Volume"
                        : "Activation Time"
                    }}
                  </p>

                  <div
                    class="grid grid-cols-2 w-full mt-1"
                    v-if="stationDetail.mode === 'volume'"
                  >
                    <div class="flex text-left text-[#353535]">
                      <p class="font-semibold">{{ stationDetail.value }}</p>
                      <p class="ml-3">volume</p>
                    </div>
                  </div>
                  <div
                    class="grid grid-cols-2 w-full mt-1"
                    v-if="stationDetail.mode === 'hour/minute'"
                  >
                    <div class="flex text-left text-[#353535]">
                      <p class="font-semibold">
                        {{ stationDetail.value.split(".")[0] }}
                      </p>
                      <p class="ml-3">Hour</p>
                    </div>
                    <div class="flex text-left text-[#353535]">
                      <p class="font-semibold">
                        {{ stationDetail.value.split(".")[1] }}
                      </p>
                      <p class="ml-3">Minute</p>
                    </div>
                  </div>
                  <div
                    class="grid grid-cols-2 w-full mt-1"
                    v-if="stationDetail.mode === 'minute/second'"
                  >
                    <div class="flex text-left text-[#353535]">
                      <p class="font-semibold">
                        {{ stationDetail.value.split(".")[0] }}
                      </p>
                      <p class="ml-3">Minute</p>
                    </div>
                    <div class="flex text-left text-[#353535]">
                      <p class="font-semibold">
                        {{ stationDetail.value.split(".")[1] }}
                      </p>
                      <p class="ml-3">Second</p>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-col text-left text-[#353535] w-full gap-2 mt-8"
                >
                  <p class="font-semibold">Start Time</p>
                  <p
                    v-if="
                      deviceGeoPlan.startTime.filter(
                        (item) => item.enable === '1'
                      ).length === 0
                    "
                  >
                    No data
                  </p>
                  <div class="table-container">
                    <table class="w-full start-time-table">
                      <thead>
                        <tr class="text-center">
                          <th>No</th>
                          <th>Hour</th>
                          <th>Minute</th>
                          <th>Cycle</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="text-center"
                          v-for="(
                            startTime, index
                          ) in deviceGeoPlan.startTime.filter(
                            (item) => item.enable === '1'
                          )"
                        >
                          <td class="py-2">{{ index + 1 }}</td>
                          <td class="py-2">{{ startTime.hour }}</td>
                          <td class="py-2">{{ startTime.minute }}</td>
                          <td class="py-2">{{ startTime.cycle }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="flex flex-col text-left text-[#353535] w-full gap-2"
                >
                  <p class="font-semibold">Schedule</p>
                  <p v-if="deviceGeoPlan.date[0].date.length === 0">
                    No Schedule
                  </p>
                  <div class="table-container">
                    <table class="w-full">
                      <thead>
                        <tr class="text-center">
                          <th>No</th>
                          <th>Start</th>
                          <th>Stop</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          class="text-center"
                          v-for="(schedule, index) in deviceGeoPlan.date[0]
                            .date"
                        >
                          <td class="py-2">{{ index + 1 }}</td>
                          <td class="py-2">{{ formatDate(schedule.start) }}</td>
                          <td class="py-2">{{ formatDate(schedule.end) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- <BaseButton type="submit" class="filled__red" :label="deleteLabel" :loading="deletePlanningLoading"
                @click="deletePlanning" /> -->
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { onClickOutside } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import { useDevicesStore } from "@/stores/DevicesStore";

//stores
const devicesStore = useDevicesStore();
const { stationDetail, deviceGeoPlan, deviceGeoPlanLoading } = storeToRefs(
  useDevicesStore()
);

const { t } = useI18n();

const props = defineProps({
  isOpen: Boolean,
  title: String,
  deviceCode: String,
  groupName: String,
});

function formatDate(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // bulan dimulai dari 0
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

watch(
  () => props.isOpen,
  async () => {
    if (props.isOpen) {
      await devicesStore.getDeviceGeoPlanning({
        deviceCode: props.deviceCode,
        groupName: props.groupName,
      });
    }
  }
);

const cancelLabel = ref(t("cancel"));
const deleteLabel = ref(t("delete"));
const regButtonClick = ref(0);
const cancelButtonClick = ref(0);

// Define custom events
const emits = defineEmits(["close"]);

const target = ref(null);

onClickOutside(target, () => {
  cancelButtonClick.value = 0;
  regButtonClick.value = 0;
  deleteLabel.value = t("delete");
  cancelLabel.value = t("cancel");
  if (props.isOpen) {
    emits("close");
  }
});
</script>

<style scoped>
.title {
  @apply text-left border-b-[1px] pb-[18px] text-[28px] font-normal text-[#353535] mb-4 sm:mb-10 text-base sm:text-xl;
}

.message-wrapper {
  @apply flex items-center gap-2;
}

.form-wrapper {
  @apply flex flex-col gap-6;
}

.modal {
  @apply bg-[#ABADAF]/20 backdrop-blur-sm w-full h-full fixed top-0 left-0 px-8 py-10 overflow-x-hidden overflow-y-auto z-[999999] justify-center items-center flex;
}

.modal-inner {
  background: white;
  @apply rounded-[40px] border-2 border-[#005CB4] max-w-[500px] w-full h-fit p-10;
}

/* .modal-content {
  @apply 
    relative w-[600px] p-[40px] bg-white gap-[30px] rounded-xl
} */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
  transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.select-option {
  @apply px-2 py-1 sm:px-3 sm:py-2 rounded-lg border bg-white text-[12px] sm:text-base;
}

.field-wrapper {
  @apply flex flex-col gap-1 text-left bg-white px-3 py-2 rounded-lg;
}

.field-wrapper label {
  @apply text-xs font-semibold;
}

.table-container {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.table-container tbody {
  display: block;
  width: 100%;
  overflow: auto;
  max-height: 200px;
}

.table-container thead tr {
  display: block;
}

.table-container th,
.table-container td {
  padding: 5px 10px;
  text-align: center;
}

.table-container th:nth-child(1),
.table-container td:nth-child(1) {
  width: 50px;
}

.table-container th:nth-child(2),
.table-container td:nth-child(2),
.table-container th:nth-child(3),
.table-container td:nth-child(3) {
  width: 185px;
}

.start-time-table th,
.start-time-table td {
  text-align: center;
  padding: 5px 10px;
}

.start-time-table th:nth-child(1),
.start-time-table td:nth-child(1) {
  width: 50px;
}

.start-time-table th:not(:first-child),
.start-time-table td:not(:first-child) {
  width: 123px;
}
</style>
